import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FeedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"feed"}/>
}
